<template>
  <div class="kebab">
    <div v-click-outside="closeKebab" class="dropdown-actions">
      <div class="atom-icon mr-0" @click="kebabOpened = !kebabOpened">
        <img src="@/assets/icons/menu/ico-kebab.svg" alt="" />
      </div>

      <div
        v-show="kebabOpened"
        class="dropdown-actions__wrapper dropdown-actions__wrapper--tiny"
      >
        <div v-if="actions.includes('update')" class="dropdown-actions__inner">
          <div
            class="dropdown-actions__item d-flex align-items-center"
            @click="$emit('update')"
          >
            <div class="atom-icon">
              <img
                src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg"
                alt=""
              />
            </div>
            {{ $filters.firstUpper($t("upravit")) }}
          </div>
        </div>
        <div v-if="actions.includes('change')" class="dropdown-actions__inner">
          <div
            class="dropdown-actions__item d-flex align-items-center"
            @click="$emit('change')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/ico-upravitzarizeni.svg" alt="" />
            </div>
            {{ $filters.firstUpper($t("CHANGE")) }}
          </div>
        </div>
        <div v-if="actions.includes('delete')" class="dropdown-actions__inner">
          <div
            class="dropdown-actions__item d-flex align-items-center"
            @click="$emit('delete')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-ico-delete-l.svg" alt="" />
            </div>
            {{ $filters.firstUpper($t("odebrat")) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "EditDeleteKebab",
  directives: {

  },
  emits: ["update", "change", "delete"],
  props: {
    actions: {
      type: Array,
      default: () => ["update", "delete"],
    },
  },
  data: () => ({
    kebabOpened: false,
  }),
  methods: {
    closeKebab() {
      this.kebabOpened = false
    },
  },
}
</script>
